import OfferActionsList from './styled';

export default OfferActionsList;
